import { injectIntl, IntlShape } from 'react-intl';
import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { PassportSettingsFormPresentation } from './passport-settings-form.presentation';
import PassportSettingsFormVM from './passport-settings-form.viewmodel';

export interface IPassportSettingsContainerProps {
    accountId: number;
    eventId: number;
    setSubdomainInPassportTab: (value: string) => void;
    accountSubdomain: string | null;
    intl: IntlShape;
}

const PassportSettingsFormContainer = injectIntl(withViewModel(PassportSettingsFormPresentation,
    (props: IPassportSettingsContainerProps) => {
        const { accountId, eventId, setSubdomainInPassportTab, accountSubdomain, intl } = props;
        const passportSettingsFormVM = new PassportSettingsFormVM(
            accountId,
            eventId,
            accountSubdomain,
            setSubdomainInPassportTab,
            intl
        );

        passportSettingsFormVM.initialize();

        return passportSettingsFormVM;
    }));

export { PassportSettingsFormContainer as PassportSettingsForm };